module.exports = __webpack_public_path__ + "static/media/sair.665237b0.svg";